// extracted by mini-css-extract-plugin
export var card = "MarkdownWideSection-module--card--58206";
export var image = "MarkdownWideSection-module--image--35799";